// Preferred link builder: use the slug stored on the record (the same one the
// backend sitemap advertises). Recomputing from the title breaks the moment a
// title is edited - the stored slug never changes, so links built from it stay
// identical to the sitemap and canonical URLs. Falls back to recomputing only
// for records that predate slug generation.
export function slugFor(item) {
  if (!item) return '';
  if (item.slug) return item.slug;
  return slugify(item.title, item._id || item.id);
}

export function slugify(title, id) {
  const base = String(title || '')
    .toLowerCase()
    .replace(/[^a-z0-9\s-]/g, '')
    .trim()
    .replace(/\s+/g, '-')
    .replace(/-+/g, '-')
    .replace(/^-|-$/g, '');
  // Mirrors backend/utils/slugGenerator.js: a title with no ASCII characters
  // (a fully Devanagari headline) leaves an empty base, and "-<id>" is a
  // meaningless url. extractIdFromSlug returns the whole string when there is
  // no dash, so a bare id still resolves.
  return base ? `${base}-${id}` : String(id);
}

export function extractIdFromSlug(idOrSlug) {
  if (idOrSlug == null) return null;
  const str = String(idOrSlug);
  const lastDash = str.lastIndexOf('-');
  if (lastDash === -1) return str;
  const tail = str.slice(lastDash + 1);
  return tail || str;
}


